/**
 * lucide-react v0.219.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const AlertCircle = createLucideIcon("AlertCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);

export { AlertCircle as default };
//# sourceMappingURL=alert-circle.js.map
